import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, unref as _unref, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { class: "control" }
const _hoisted_4 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_5 = {
  key: 1,
  class: "help is-danger"
}
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "control" }
const _hoisted_8 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_9 = {
  key: 1,
  class: "help is-danger"
}
const _hoisted_10 = { class: "field" }

import Toast from '@/shared/services/toast';
import ReadonlyField from '@/shared/components/ReadonlyField.vue';
import Modal from '@/shared/components/Modal.vue';
import { UpdateContactAttributeViewModel } from '@/messaging/models/updateContactAttributeViewModel';
import { ContactAttributeViewModel } from '@/messaging/models/contactAttributeViewModel';
import { ContactAttributeType } from '@/messaging/models/contactAttributeType';
import { UPDATE_CONTACT_ATTRIBUTE } from '@/store/attributes/actionTypes';
import { computed, onMounted, PropType, ref, watch } from 'vue';
import { useStore } from 'vuex';
import useVuelidate from '@vuelidate/core';
import { required, maxLength } from '@vuelidate/validators';


export default /*@__PURE__*/_defineComponent({
  __name: 'UpdateAttribute',
  props: {
  attribute: {
    type: Object as PropType<ContactAttributeViewModel>,
    required: true,
  },
},
  emits: ["cancel", "update"],
  setup(__props, { emit: __emit }) {

const props = __props;

const store = useStore();
const updateAttribute = (request: {
  attributeId: string;
  request: UpdateContactAttributeViewModel;
}): Promise<ContactAttributeViewModel> => {
  return store.dispatch(UPDATE_CONTACT_ATTRIBUTE, request);
};

const request = ref<UpdateContactAttributeViewModel>({ description: '', name: '' });
const updateInProgress = ref(false);
const nameInput = ref<HTMLInputElement | null>(null);

const emit = __emit;

const submitDisabled = computed(() => {
  return (
    $v.value.$invalid ||
    (props.attribute.description === request.value.description && props.attribute.name === request.value.name)
  );
});

const attributeType = computed(() => {
  return Object.keys(ContactAttributeType).filter((x) => (ContactAttributeType as any)[x] === props.attribute.type)[0];
});

const validName = (value: string) => value.search(/[^a-zA-Z0-9 _\-]/) === -1;
const validations = {
  request: {
    description: {
      required,
      maxLength: maxLength(255),
    },
    name: {
      required,
      validName,
      maxLength: maxLength(50),
    },
  },
};

const $v = useVuelidate(validations, { request });

watch(
  () => props.attribute,
  (to) => {
    request.value.description = to.description;
    request.value.name = to.name;
  },
  { immediate: true },
);

onMounted(() => {
  if (nameInput.value) {
    nameInput.value.focus();
  }
});

function closeModal() {
  emit('cancel');
}

function isFieldNotPopulated(vuelidateObject: any, fieldName: string): boolean {
  const field = vuelidateObject[fieldName];
  return !field || (field.$invalid && !field.required && field.$dirty);
}

function isFieldInvalid(vuelidateObject: any, fieldName: string): boolean {
  const field = vuelidateObject[fieldName];
  return !field || (field.$invalid && field.$dirty);
}

async function update() {
  if (updateInProgress.value) {
    return;
  }

  updateInProgress.value = true;
  try {
    const updatedAttribute = await updateAttribute({ attributeId: props.attribute.id, request: request.value });
    Toast.showSuccess('Attribute successfully updated');
    emit('update', updatedAttribute);
  } catch (err) {
    Toast.showError(err.message);
  } finally {
    updateInProgress.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!

  return (_openBlock(), _createBlock(Modal, { onCancel: closeModal }, {
    title: _withCtx(() => _cache[4] || (_cache[4] = [
      _createElementVNode("p", { class: "modal-card-title" }, "Update Contact Attribute", -1)
    ])),
    body: _withCtx(() => [
      _createElementVNode("fieldset", null, [
        _createElementVNode("div", _hoisted_1, [
          _cache[5] || (_cache[5] = _createElementVNode("label", { class: "label" }, "ID", -1)),
          _createVNode(ReadonlyField, {
            readonlyValue: __props.attribute.id
          }, null, 8, ["readonlyValue"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _cache[6] || (_cache[6] = _createElementVNode("label", {
            class: "label",
            for: "name"
          }, "Name", -1)),
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              ref_key: "nameInput",
              ref: nameInput,
              type: "text",
              class: "input",
              id: "name",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((request.value.name) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref($v).request.name.$touch()))
            }, null, 544), [
              [_vModelText, request.value.name]
            ]),
            (isFieldNotPopulated(_unref($v).request, 'name'))
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Name is required"))
              : (isFieldInvalid(_unref($v).request, 'name'))
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Name may only contain letters, numbers, spaces, underscores or hyphens, and must be no longer than 50 characters "))
                : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[7] || (_cache[7] = _createElementVNode("label", {
            class: "label",
            for: "description"
          }, "Description", -1)),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("textarea", {
              ref: "descriptionInput",
              class: "textarea",
              id: "description",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((request.value.description) = $event)),
              onInput: _cache[3] || (_cache[3] = ($event: any) => (_unref($v).request.description.$touch()))
            }, null, 544), [
              [_vModelText, request.value.description]
            ]),
            (isFieldNotPopulated(_unref($v).request, 'description'))
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Description is required"))
              : (isFieldInvalid(_unref($v).request, 'description'))
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Description must be no longer than 255 characters "))
                : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[8] || (_cache[8] = _createElementVNode("label", { class: "label" }, "Data type", -1)),
          _createVNode(ReadonlyField, { readonlyValue: attributeType.value }, null, 8, ["readonlyValue"])
        ])
      ])
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_n_button_group, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            id: "create-attribute-submit-btn",
            type: "button",
            variant: "primary",
            disabled: submitDisabled.value,
            loading: updateInProgress.value,
            onClick: update
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("Update Attribute")
            ])),
            _: 1
          }, 8, ["disabled", "loading"]),
          _createVNode(_component_n_button, {
            onClick: closeModal,
            variant: "primary--outline"
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("Cancel")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})